import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as LockIcon } from 'assets/img/icons/lock-fill.svg';

/**
 * @param {object} props
 * @param {import('utils/types').Size} [props.size='sm']
 * @param {string} [props.text='LOCKED']
 * @param {string} [props.className]
 */
export default function LockBadge({ size = 'md', text = '', className = '' }) {
  return (
    <UiKit.Tag
      mode="dark"
      size={size}
      className={cn(styles.container, className)}
    >
      <LockIcon />
      {text}
    </UiKit.Tag>
  );
}
